export default {
    key: "portal_action_log",
    action: ["view"],
    sort_fields:[
        "id",
        "action",
        "target",
        "target_id",
        "cre_dttm",
    ],
    sort: {
        field: "id",
        order: "desc"
    },
    filters:{
        id: {},
        action: {
            type: "select",
            label: "name",
            value: "code"
        },
        target: {
            type: "select",
            label: "name",
            value: "code"
        },
        target_id: {},
        cre_user: {
            type: "select",
            label: "name",
            value: "id"
        },
    },
    fields: [
        {key: "id", width:80},
        {key: "action", width:120, type:"select", options: {key: "portal_action_log_action",label: "name",value: "code"}},
        {key :"target", width:150, type:"select", options: {key: "portal_action_log_target",label: "name",value: "code"}},
        {key :"target_id", width:100},
        {key :"old_data"},
        {key :"new_data"},
        {key: "cre_user", width:100, field: "cre_user.name", value: "cre_user.id", type: "select"},
        {key :"cre_dttm", width:120, type: "datetime"},
        {key: "action_button", type: "action-btn", width: "50px"},
    ],
    view: [
      ["id","action"],
      ["target","target_id"],
      ["old_data"],
      ["new_data"],
      ["remark"],
      [{key: "cre_user", value: "cre_user.name", type: "select"},{key :"cre_dttm", type: "datetime"}],
    ],
    
    options: {
        cre_user: {
            key: "users",
            label: "name",
            value: "id"
        },
        action: {
            key: "portal_action_log_action",
            label: "name",
            value: "code"
        },
        target: {
            key: "portal_action_log_target",
            label: "name",
            value: "code"
        },
    },
    structure:[],
    disabled_by_column:{},
    extra_components: {}
}